import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { StickyNote } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { useCreateNote } from '../hooks/useNoteMutations';

/** Rendered at `/:orgId/notes` — no note selected yet. */
export function NotesEmptyPlaceholder() {
  const { t } = useTranslation('notes');
  const navigate = useNavigate();
  const { orgId } = useParams<{ orgId: string }>();
  const createNote = useCreateNote();

  const handleCreate = () => {
    createNote.mutate(
      { title: null, content: '<p></p>' },
      {
        onSuccess: (note) => {
          if (note.id) navigate(`/${orgId}/notes/${note.id}`);
        },
      },
    );
  };

  return (
    <div
      className="flex h-full flex-col items-center justify-center gap-4 p-8 text-center"
      data-testid="notes-editor-empty-state"
    >
      <StickyNote className="h-12 w-12 text-muted-foreground/50" />
      <p className="text-base font-semibold text-foreground">{t('placeholder.title')}</p>
      <Button
        onClick={handleCreate}
        disabled={createNote.isPending}
        data-testid="notes-placeholder-create-button"
      >
        {t('placeholder.action')}
      </Button>
    </div>
  );
}
